import { useEffect, useState } from 'react';
import { create } from 'zustand';
import { Button } from './button';
import { Dialog } from './dialog';
import { Textarea } from './input';

interface Ask { title: string; label: string; placeholder?: string; confirm: string; description?: string; min?: number; resolve(v: string | null): void }
const useAsk = create<{ ask: Ask | null }>(() => ({ ask: null }));

/** Asks for a mandatory remark (at least `min` characters); resolves null if the user cancels. */
export function askText(o: Omit<Ask, 'resolve'>): Promise<string | null> {
  return new Promise((resolve) => useAsk.setState({ ask: { ...o, resolve } }));
}

/** Mounted once at the app root. */
export function AskTextHost() {
  const ask = useAsk((s) => s.ask);
  const [text, setText] = useState('');
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => { setText(''); setErr(null); }, [ask]);
  const close = (v: string | null) => { ask?.resolve(v); useAsk.setState({ ask: null }); };
  const min = ask?.min ?? 3;
  return (
    <Dialog
      open={!!ask}
      onOpenChange={(o) => !o && close(null)}
      title={ask?.title ?? ''}
      description={ask?.description}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={() => close(null)}>Cancel</Button>
          <Button onMouseDown={(e) => e.preventDefault()} onClick={() => (text.trim().length < min ? setErr(`Write at least ${min} characters`) : close(text.trim()))}>{ask?.confirm}</Button>
        </>
      }
    >
      <label htmlFor="ask-text" className="text-[13px] font-medium">{ask?.label} <span className="text-danger">*</span></label>
      <Textarea id="ask-text" className="mt-1.5" rows={3} value={text} invalid={!!err} onChange={(e) => { setText(e.target.value); if (err && e.target.value.trim().length >= min) setErr(null); }} placeholder={ask?.placeholder} autoFocus />
      {err && <p className="mt-1 text-xs text-danger" role="alert">{err}</p>}
    </Dialog>
  );
}
